export default __webpack_public_path__ + "static/media/Captain's Chestguard of the Warring States.cf5da497.jpg";